import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
import { defaultConfig } from "../config/tom-select";

export default class extends Controller {
  static values = {
    url: String,
    errorMessage: String,
    noSitesMessage: String,
  };
  static targets = ["nameInput", "siteSelect", "message"];

  connect() {
    if (this.siteSelectTarget.tomselect) {
      return;
    }

    this._ts = new TomSelect(this.siteSelectTarget, this._config());
  }

  disconnect() {
    if (!this.hasSiteSelectTarget || !this.siteSelectTarget.tomselect) {
      return;
    }

    // Morphdom-safe teardown: overwrite revertSettings cache before destroy so
    // a re-connect starts from the current options, not stale HTML.
    this.siteSelectTarget.tomselect.revertSettings = {
      innerHTML: this.siteSelectTarget.innerHTML,
      tabIndex: this.siteSelectTarget.tabIndex,
    };
    this.siteSelectTarget.tomselect.destroy();
  }

  syncName() {
    const currentValue = this._ts.getValue();
    const option = this._ts.options[currentValue];
    this.nameInputTarget.value = option?.text ?? "";
  }

  _config() {
    return Object.assign({}, defaultConfig, {
      create: false,
      maxItems: 1,
      onItemAdd: () => this._ts?.blur(),
      preload: "focus",
      shouldLoad: () => !this._ts?.loadedSearches[""],
      load: (_query, callback) => this._load(callback),
    });
  }

  async _load(callback) {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      });
      const data = await response.json();
      if (!this.element.isConnected) {
        callback([]);
        return;
      }

      if (!response.ok || data.error) {
        throw new Error("Failed to load sites");
      }

      const { sites, taken_vyer_site_ids } = data;

      callback(
        sites.map((site) => ({
          value: site["id"],
          text: site["name"],
          disabled: taken_vyer_site_ids.includes(site["id"]),
        }))
      );

      if (sites.length === 0) {
        this._showMessage(this.noSitesMessageValue);
      } else {
        this._clearMessage();
      }
    } catch {
      this._showMessage(this.errorMessageValue);
      callback([]);
    }
  }

  _showMessage(text) {
    this.messageTarget.textContent = text;
  }

  _clearMessage() {
    this.messageTarget.textContent = "";
  }
}
